// extracted by mini-css-extract-plugin
module.exports = {"element_wrapper":"NothingToDisplay_element_wrapper__5DH19","card":"NothingToDisplay_card___eqYS"};